import React from "react";
import * as styles from "./styles";

const BulkReviewTitle: React.FunctionComponent = () => {
  return <h1 style={styles.bulkReviewTitle}>Bulk Review</h1>;
};

export default BulkReviewTitle;
